<template>
  <div class="container-fluid cap-nav">
    <div class="d-flex justify-content-between align-items-center">
      <!-- .col -->
      <div id="logo">
        <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 1207 282"
          style="enable-background:new 0 0 1207 282;"
          xml:space="preserve"
        >
          <g>
            <path
              d="M60.6,88.9c2,10.8,5.8,20.7,7.9,31H92c0.6-9-3.5-16.1-9.3-22C76.9,92,69.7,88.7,60.6,88.9 M66.5,192.7
		c7.7-0.8,13.7-4.7,18.2-10.2c4.9-5.9,8.6-12.7,7.1-21H69.6c-1.8,4.5-3.8,8.7-9.3,8.4C62.3,177.5,64.3,184.9,66.5,192.7
		 M204.9,129.7c1.1,4.1,2,7.8,3.2,11.5c1,3.2,1.5,6.5,2.9,9.6c0.6,1.4,1.3,1.5,2.2,1.3c7.2-2.4,13.2-6.2,17.7-12.5
		c4.4-6.3,6.7-13.2,6.1-20.7c-0.3-3.6-1.1-7.2-2.7-10.8c-2-4.5-5-7.8-8.2-11.1c-3-3.1-6.5-5.5-10.7-6.6c-3.4-0.8-6.7-2.4-10.5-1.1
		c0.5,1.2,1,2,1.2,3c1.2,4.7,2.2,9.4,3.5,14.1c1.1,4.2,2.8,8.2,3.6,12.4c0.4,1.8,0.3,3.8-0.7,5.9C210.9,128,208.2,128.9,204.9,129.7
		 M126.1,88.9c0.5,0.9,1.1,1.5,1.1,2c0.2,2.6,0.1,5.2,0.9,7.9c0.6,2,0.6,4.2,1.1,6.3c0.5,2.2,0.5,4.5,1,6.8c1,4.5,1.3,9.1,2.1,13.6
		c0.8,4.5,1.2,9.1,2.1,13.6c0.4,2.1,0.4,4.2,1,6.3c0.6,2.2,0.5,4.5,1,6.8c0.9,4.5,1.2,9.1,2.1,13.6c0.4,2.2,0.8,4.5,1.1,6.8
		c0.3,2.3,0.4,4.5,0.9,6.9c0.5,2.2,1.1,4.5,1.1,6.8c0,2.6,1,4.8,1.6,7.3c7.6,0,15.1,0,22.7,0c0.1,0,0.3-0.1,0.4-0.2
		c0.1-0.1,0.2-0.3,0.4-0.5c-0.4-0.8-1.1-1.7-1.1-2.5c0.3-6.1-2.4-11.7-2.1-17.8c0-0.5,0-1.2-0.2-1.4c-1.5-1.3-0.5-2.9-0.8-4.4
		c-0.4-1.6-0.8-3.1-1-4.8c-0.4-3.3-0.3-6.7-1.2-9.9c-1.1-4.2-1-8.5-2.1-12.6c-0.8-2.8-0.2-5.8-1.1-8.3c-0.7-2-0.2-4.1-0.9-5.8
		c-0.9-2.1-0.9-4.2-0.9-6.4c0-0.5,0.2-1.3,0-1.5c-1.9-1.7-0.2-4.1-1.1-5.8c-1-2-0.9-3.9-0.9-5.8c0-0.7,0.3-1.7-0.1-2
		c-1.7-1.6-0.3-3.8-1-5.3c-1-1.9-0.9-3.8-0.9-5.8c-0.1-3.6-0.4-3.9-4.2-3.9C140.1,88.9,133.4,88.9,126.1,88.9 M157.3,7
		c0.1,0.3,0.2,0.8,0.4,0.9c1.5,0.1,3.1,0,4.6,0.2c1.4,0.2,2.8,0.7,4.2,1c8.2,1.7,16.3,3.6,24.1,6.7c6,2.4,11.6,5.4,17.3,8.2
		c5.2,2.6,10.1,5.8,14.7,9.5c5.5,4.4,11.3,8.6,16,13.9c4.3,4.8,8.2,10,12.2,15.1c6.6,8.4,11.1,17.8,15.5,27.3
		c2.8,6,4.7,12.2,6.2,18.7c0.9,3.7,0.9,7.7,2.9,11.2c-0.7,3.6,1.1,6.9,1,10.4c0,7.8-0.1,15.5,0,23.3c0,2.1-0.8,3.9-1.1,5.8
		c-0.4,1.9,1,4.1-1,5.8c-0.1,5.1-1.9,9.9-3.2,14.7c-0.7,2.8-1.2,5.8-2.4,8.3c-3.2,7-6.6,13.8-10.1,20.7c-2.7,5.4-6.2,10.3-10,15
		c-4,5.1-8,10.4-12.9,14.9c-4.8,4.3-10,8.2-15.1,12.2c-8.3,6.6-17.8,11.1-27.3,15.5c-5.9,2.8-12.2,4.7-18.7,6.2
		c-3.7,0.8-7.6,1.3-11.2,2.8c-1.5,0.6-3.4,0-5.1,0.1c-0.5,0-0.9,0.6-1.4,1h-31.1c-0.4-0.4-0.9-1-1.3-1c-5.4,0.5-10.4-2.4-15.7-2.1
		c-5.2-2.9-11.6-2.6-16.6-6.2c-4.1-0.2-7-3.1-10.6-4.5c-3.6-1.4-7.1-3-10.3-5.1c-8.4-5.6-16.6-11.5-23.9-18.6
		c-3.1-3.1-5.9-6.5-8.8-9.8c-1.8-2-3.5-4-5.1-6.2c-2.8-3.8-6-7.5-8.1-11.7C20,200.2,14,189,11.1,176.6c-0.7-3.2-1.3-6.4-2-9.5
		c-0.3-1.4-0.8-2.8-1-4.2c-0.2-1.7-0.1-3.4-0.2-5.1c0-0.1-0.6-0.2-0.8-0.4v-31.1c0.3-0.1,0.8-0.2,0.8-0.4c0.1-1.5,0-3.1,0.2-4.6
		c0.2-1.6,0.7-3.2,1-4.8c0.7-3.2,1.1-6.4,2-9.5c1.7-5.9,3.2-11.8,6-17.2c4.7-9.4,8.2-19.4,15.7-27.2c3.1-6,8.1-10.6,12.5-15.5
		c2.7-3,6-5.5,9-8.1c2-1.8,4-3.5,6.2-5.1c3.8-2.8,7.5-6,11.7-8.1C83.4,20,94.5,14,107,11.1c3.2-0.7,6.4-1.3,9.5-2
		c1.4-0.3,2.8-0.8,4.2-1c1.7-0.2,3.4-0.1,5.1-0.2c0.1,0,0.2-0.6,0.4-0.9L157.3,7L157.3,7z"
            ></path>
            <path
              d="M509.8,252h-14.8v-8.6h13.7v-9.9h-13.7v-7.2h14.8v-9.9h-27.1V262h27.1V252z M471.9,252.1h-20.2l19.7-28.1v-7.6h-34.6v10
		h19.3l-19.7,28v7.6h35.5L471.9,252.1L471.9,252.1z M425.4,216.4H413V262h12.4V216.4z M377.6,225.8h2.4c4.2,0,6.3,1.6,6.3,4.7
		c0,3.8-2.1,5.7-6.5,5.7h-2.3L377.6,225.8L377.6,225.8z M380.7,245.4l9.7,16.6h14L391,242.2c5.1-2.9,7.7-7,7.7-12.2
		c0-9-6.2-13.5-18.6-13.5h-14.9V262h12.3v-16.6H380.7z M334.1,226.4h3.2c3.4,0,5.1,1.5,5.1,4.6c0,1.8-0.5,3.3-1.6,4.3
		c-1.1,1-2.6,1.6-4.4,1.6h-2.2L334.1,226.4L334.1,226.4z M350.6,220.2c-2.9-2.5-7.2-3.8-13-3.8h-15.8V262h12.3v-15.1h3.5
		c5.5,0,9.8-1.4,12.8-4.2c3-2.8,4.5-6.7,4.5-11.8C354.9,226.3,353.5,222.7,350.6,220.2"
            ></path>
            <path
              d="M1158,152.5h-13.4l15,28.2v17.4h12.4v-17.8l15-27.8h-13.3l-7.9,16.9L1158,152.5z M1135.5,152.5h-12.4v16.9h-14.3v-16.9
		h-12.4v45.6h12.4v-18.6h14.3v18.6h12.4V152.5z M1065.3,162.5h3.2c3.4,0,5.1,1.5,5.1,4.6c0,1.8-0.6,3.3-1.6,4.3s-2.6,1.6-4.4,1.6
		h-2.2V162.5z M1081.7,156.3c-2.9-2.5-7.2-3.8-13-3.8H1053v45.6h12.3V183h3.5c5.5,0,9.8-1.4,12.8-4.2c3-2.8,4.5-6.7,4.5-11.8
		C1086.1,162.4,1084.6,158.8,1081.7,156.3 M1015.9,179.5c1.9-7.2,3.1-12,3.7-14.4c0.6-2.4,0.9-4.2,1.1-5.2c0.2,1.1,0.6,3,1.3,5.7
		c0.7,2.6,1.2,4.8,1.7,6.5l2,7.5H1015.9z M1043.8,198.2l-15.1-45.8h-16.4l-14.9,45.8h13.5l2.3-8.5h14.8l2.2,8.5H1043.8z
		 M964.6,161.9h2.4c4.2,0,6.3,1.6,6.3,4.7c0,3.8-2.2,5.7-6.5,5.7h-2.3L964.6,161.9L964.6,161.9z M967.7,181.6l9.7,16.6h14
		l-13.3-19.9c5.2-2.9,7.7-7,7.7-12.3c0-9-6.2-13.5-18.6-13.5h-14.9v45.6h12.3v-16.6L967.7,181.6L967.7,181.6z M919.5,181h8.1v7.1
		c-1.5,0.4-3.2,0.5-5,0.5c-3.3,0-5.9-1.1-7.7-3.4c-1.8-2.2-2.7-5.5-2.7-9.8c0-4.4,1-7.7,3-10c2-2.3,4.8-3.5,8.3-3.5
		c3.9,0,7.5,0.8,10.8,2.4l3.9-9.7c-1.9-0.8-4.1-1.5-6.7-2.1c-2.5-0.5-5.3-0.8-8.1-0.8c-7.6,0-13.5,2-17.7,6.1
		c-4.2,4.1-6.3,9.8-6.3,17.2c0,7.5,1.9,13.4,5.8,17.4c3.8,4.1,9.3,6.1,16.3,6.1c6.4,0,12.3-0.9,17.6-2.8v-24.6h-19.7L919.5,181
		L919.5,181z M867.4,161.9c3,0,5.3,1.1,6.8,3.3c1.5,2.2,2.3,5.5,2.3,10.1c0,4.5-0.8,7.9-2.3,10c-1.5,2.1-3.8,3.2-6.9,3.2
		c-6.1,0-9.2-4.4-9.2-13.2C858.2,166.4,861.2,161.9,867.4,161.9 M883.9,157.8c-3.8-4-9.2-6-16.5-6c-7.2,0-12.8,2-16.5,6
		c-3.8,4-5.7,9.8-5.7,17.4c0,7.7,1.9,13.5,5.7,17.5c3.8,4,9.3,6,16.5,6c7.3,0,12.8-2,16.5-6c3.8-4,5.7-9.8,5.7-17.5
		C889.5,167.6,887.7,161.8,883.9,157.8 M825.9,162.6H837v-10.1h-34.6v10.1h11.1v35.5H826L825.9,162.6L825.9,162.6z M772.2,161.9
		c3,0,5.3,1.1,6.8,3.3c1.5,2.2,2.3,5.5,2.3,10.1c0,4.5-0.8,7.9-2.3,10c-1.5,2.1-3.8,3.2-6.9,3.2c-6.1,0-9.2-4.4-9.2-13.2
		C762.9,166.4,766,161.9,772.2,161.9 M788.7,157.8c-3.8-4-9.2-6-16.5-6c-7.2,0-12.8,2-16.5,6c-3.8,4-5.7,9.8-5.7,17.4
		c0,7.7,1.9,13.5,5.7,17.5s9.3,6,16.5,6c7.3,0,12.8-2,16.5-6s5.7-9.8,5.7-17.5C794.3,167.6,792.4,161.8,788.7,157.8 M738.2,152.5
		h-12.4v16.9h-14.3v-16.9h-12.4v45.6h12.4v-18.6h14.3v18.6h12.4V152.5z M668,162.5h3.2c3.4,0,5.1,1.5,5.1,4.6c0,1.8-0.5,3.3-1.6,4.3
		c-1.1,1-2.6,1.6-4.4,1.6H668V162.5z M684.4,156.3c-2.9-2.5-7.2-3.8-13-3.8h-15.8v45.6H668V183h3.5c5.5,0,9.8-1.4,12.8-4.2
		s4.5-6.7,4.5-11.8C688.8,162.4,687.3,158.8,684.4,156.3 M624.1,152.5h-11v20.6c0,2.8,0.2,6.5,0.4,11.1h-0.2l-16.6-31.7h-16.1v45.6
		h10.9v-20.6c0-2.7-0.2-6.5-0.6-11.6h0.3l16.7,32.1h16.2L624.1,152.5L624.1,152.5z M543.6,179.5c1.9-7.2,3.1-12,3.7-14.4
		c0.5-2.4,0.9-4.2,1.1-5.2c0.2,1.1,0.6,3,1.3,5.7c0.7,2.6,1.2,4.8,1.7,6.5l2,7.5H543.6z M571.6,198.2l-15.1-45.8h-16.4l-14.9,45.8
		h13.5l2.3-8.5h14.8l2.2,8.5H571.6z M509.9,162.8c1.7,0.5,3.4,1.2,5,2l3.8-9.7c-4.5-2.1-9.2-3.2-14.1-3.2c-4.5,0-8.4,1-11.8,2.9
		s-5.9,4.7-7.7,8.2c-1.8,3.6-2.7,7.7-2.7,12.5c0,7.5,1.8,13.3,5.5,17.3s8.9,6,15.8,6c4.8,0,9.1-0.9,12.9-2.5v-10.4
		c-1.9,0.8-3.8,1.5-5.7,2s-3.8,0.8-5.9,0.8c-6.7,0-10-4.4-10-13.2c0-4.2,0.8-7.5,2.5-9.9c1.6-2.4,3.9-3.6,6.9-3.6
		C506.4,162,508.2,162.3,509.9,162.8 M470.6,152.5h-12.4v45.6h12.4V152.5z M422.8,161.9h2.4c4.2,0,6.3,1.6,6.3,4.7
		c0,3.8-2.2,5.7-6.5,5.7h-2.3L422.8,161.9L422.8,161.9z M425.9,181.6l9.7,16.6h14l-13.3-19.9c5.2-2.9,7.7-7,7.7-12.3
		c0-9-6.2-13.5-18.6-13.5h-14.9v45.6h12.3v-16.6L425.9,181.6L425.9,181.6z M384.5,181h13.7v-9.9h-13.7v-8.7h14.8v-9.9h-27v45.6h12.1
		V181z M335.3,179.5c1.9-7.2,3.1-12,3.7-14.4c0.5-2.4,0.9-4.2,1.1-5.2c0.2,1.1,0.6,3,1.3,5.7c0.7,2.6,1.2,4.8,1.7,6.5l2,7.5H335.3z
		 M363.3,198.2l-15.1-45.8h-16.4l-14.9,45.8h13.5l2.3-8.5h14.8l2.2,8.5H363.3z"
            ></path>
            <path
              d="M1022.2,88.7h-13.4l15,28.2v17.4h12.4v-17.8l15-27.8h-13.3l-7.9,16.9L1022.2,88.7z M980.6,98h2.4c4.2,0,6.3,1.6,6.3,4.7
		c0,3.8-2.2,5.7-6.5,5.7h-2.3L980.6,98L980.6,98z M983.7,117.7l9.7,16.6h14l-13.3-19.9c5.2-2.9,7.7-7,7.7-12.2
		c0-9-6.2-13.5-18.6-13.5h-14.9v45.6h12.3v-16.6H983.7z M931.2,115.6c1.9-7.1,3.1-12,3.7-14.4c0.6-2.4,0.9-4.2,1.1-5.2
		c0.2,1.1,0.6,3,1.3,5.7c0.7,2.6,1.2,4.8,1.7,6.5l2,7.5L931.2,115.6L931.2,115.6z M959.2,134.3l-15.1-45.8h-16.4l-14.9,45.8h13.5
		l2.3-8.5h14.8l2.2,8.5H959.2z M879.9,98h2.4c4.2,0,6.3,1.6,6.3,4.7c0,3.8-2.2,5.7-6.5,5.7H880L879.9,98L879.9,98z M883.1,117.7
		l9.7,16.6h14l-13.3-19.9c5.2-2.9,7.7-7,7.7-12.2c0-9-6.2-13.5-18.6-13.5h-14.9v45.6H880v-16.6H883.1z M833.6,98
		c3,0,5.3,1.1,6.8,3.2c1.5,2.2,2.3,5.5,2.3,10.1c0,4.5-0.8,7.9-2.3,10c-1.5,2.1-3.8,3.2-6.9,3.2c-6.1,0-9.2-4.4-9.2-13.2
		C824.4,102.5,827.5,98,833.6,98 M850.1,93.9c-3.8-4-9.2-6-16.5-6c-7.2,0-12.8,2-16.5,6c-3.8,4-5.7,9.8-5.7,17.4
		c0,7.7,1.9,13.5,5.7,17.5c3.8,4,9.3,6,16.5,6c7.3,0,12.8-2,16.5-6c3.8-4,5.7-9.8,5.7-17.5C855.8,103.7,853.9,97.9,850.1,93.9
		 M781.3,98.6h3.2c3.4,0,5.1,1.5,5.1,4.6c0,1.8-0.5,3.3-1.6,4.3c-1.1,1-2.6,1.6-4.4,1.6h-2.2V98.6z M797.8,92.4
		c-2.9-2.5-7.2-3.8-13-3.8H769v45.6h12.3v-15.1h3.5c5.5,0,9.8-1.4,12.8-4.2c3-2.8,4.5-6.7,4.5-11.8
		C802.1,98.5,800.7,94.9,797.8,92.4 M735.1,134.3l9.2-32.8h0.3c-0.2,5-0.4,8-0.4,9.3c0,1.3,0,2.4,0,3.5v20h11.3V88.7H739l-9.3,32.4
		h-0.2l-9.5-32.4h-16.4v45.6h10.9v-19.8c0-3.1-0.2-7.4-0.7-13h0.3l9.3,32.8L735.1,134.3L735.1,134.3z M691.1,124.2h-14.8v-8.6H690
		v-9.9h-13.7v-7.2h14.8v-9.9H664v45.6h27.1V124.2z M643,98.7h11.1V88.7h-34.6v10.1h11.1v35.5H643L643,98.7L643,98.7z M609.6,88.7
		h-11v20.6c0,2.8,0.1,6.5,0.4,11.1h-0.2l-16.6-31.7h-16.1v45.6h10.9v-20.6c0-2.7-0.2-6.5-0.6-11.6h0.3l16.7,32.1h16.2L609.6,88.7
		L609.6,88.7z M532.2,98c3,0,5.3,1.1,6.8,3.2c1.5,2.2,2.3,5.5,2.3,10.1c0,4.5-0.8,7.9-2.3,10s-3.8,3.2-6.9,3.2
		c-6.1,0-9.2-4.4-9.2-13.2C522.9,102.5,526,98,532.2,98 M548.7,93.9c-3.8-4-9.2-6-16.5-6c-7.2,0-12.8,2-16.5,6
		c-3.8,4-5.7,9.8-5.7,17.4c0,7.7,1.9,13.5,5.7,17.5c3.8,4,9.3,6,16.5,6c7.3,0,12.8-2,16.5-6c3.8-4,5.7-9.8,5.7-17.5
		C554.3,103.7,552.4,97.9,548.7,93.9 M493.2,98.9c1.7,0.5,3.4,1.2,5.1,2l3.8-9.7c-4.5-2.1-9.2-3.2-14.1-3.2c-4.5,0-8.4,1-11.8,2.9
		c-3.3,1.9-5.9,4.7-7.7,8.2c-1.8,3.6-2.7,7.7-2.7,12.5c0,7.5,1.8,13.3,5.5,17.3c3.7,4,9,6,15.8,6c4.8,0,9.1-0.8,12.9-2.5v-10.4
		c-1.9,0.8-3.8,1.5-5.7,2c-1.9,0.6-3.8,0.9-5.9,0.9c-6.7,0-10-4.4-10-13.2c0-4.2,0.8-7.5,2.5-9.9c1.6-2.4,3.9-3.6,6.9-3.6
		C489.8,98.1,491.6,98.4,493.2,98.9 M442.7,124.2h-14.8v-8.6h13.7v-9.9h-13.7v-7.2h14.8v-9.9h-27.1v45.6h27.1V124.2z M402,88.7
		h-12.4v16.9h-14.3V88.7H363v45.6h12.4v-18.6h14.3v18.6H402V88.7z M341.9,98.7H353V88.7h-34.6v10.1h11.1v35.5h12.3V98.7z"
            ></path>
            <path
              d="M661.2,60.3h-14.8v-8.6h13.7v-9.9h-13.7v-7.2h14.8v-9.9h-27.1v45.6h27.1L661.2,60.3L661.2,60.3z M623.2,60.4H603l19.7-28.1
		v-7.6h-34.6v9.9h19.3l-19.7,28v7.6h35.5V60.4z M576.7,24.8h-12.4v45.6h12.4V24.8z M528.9,34.1h2.4c4.2,0,6.3,1.6,6.3,4.7
		c0,3.8-2.2,5.7-6.5,5.7h-2.3V34.1z M532,53.8l9.7,16.6h14l-13.3-19.9c5.2-2.9,7.7-7,7.7-12.3c0-9-6.2-13.5-18.6-13.5h-14.9v45.6
		h12.3V53.8H532z M485.5,34.7h3.2c3.4,0,5.1,1.5,5.1,4.6c0,1.8-0.5,3.3-1.6,4.3c-1.1,1-2.6,1.6-4.4,1.6h-2.2V34.7z M501.9,28.5
		c-2.9-2.5-7.2-3.8-13-3.8h-15.8v45.6h12.3V55.2h3.5c5.5,0,9.8-1.4,12.8-4.2c3-2.8,4.5-6.7,4.5-11.8
		C506.2,34.6,504.8,31.1,501.9,28.5 M430.7,34.7h3.2c3.4,0,5.1,1.5,5.1,4.6c0,1.8-0.5,3.3-1.6,4.3c-1.1,1-2.6,1.6-4.4,1.6h-2.2V34.7
		z M447.1,28.5c-2.9-2.5-7.2-3.8-13-3.8h-15.8v45.6h12.3V55.2h3.5c5.5,0,9.8-1.4,12.8-4.2c3-2.8,4.5-6.7,4.5-11.8
		C451.5,34.6,450,31.1,447.1,28.5 M381.3,51.7c1.9-7.2,3.1-12,3.7-14.4c0.5-2.4,0.9-4.2,1.1-5.2c0.2,1.1,0.6,3,1.3,5.7
		c0.7,2.6,1.2,4.8,1.7,6.5l2,7.5H381.3z M409.2,70.4l-15.1-45.8h-16.4l-14.9,45.8h13.5l2.3-8.5h14.8l2.2,8.5H409.2z M347.5,35
		c1.7,0.5,3.4,1.2,5.1,2l3.8-9.7c-4.5-2.1-9.2-3.2-14.1-3.2c-4.5,0-8.4,1-11.8,2.9c-3.3,1.9-5.9,4.7-7.7,8.2
		c-1.8,3.6-2.7,7.7-2.7,12.5c0,7.5,1.8,13.3,5.5,17.3c3.7,4,9,6,15.8,6c4.8,0,9.1-0.9,12.9-2.5V58c-1.9,0.8-3.8,1.5-5.7,2
		c-1.9,0.6-3.9,0.9-5.9,0.9c-6.7,0-10-4.4-10-13.2c0-4.2,0.8-7.5,2.5-9.9c1.6-2.4,3.9-3.6,6.9-3.6C344,34.2,345.9,34.5,347.5,35"
            ></path>
          </g>
        </svg>
      </div>

      <!-- .col -->
      <div>
        <base-icon name="log-out">
          <a href="#" @click="signOut()">Sign out</a>
        </base-icon>
      </div>
      <!-- .col -->
    </div>
    <!-- row -->
  </div>
</template>

<script>
export default {
  components: {},
  methods: {
    signOut() {
      this.$store.dispatch('auth/signOut')
    }
  }
}
</script>

<style scoped>
a {
  color: black;
}
#logo {
  width: 100%;
  max-width: 315px;
  padding-top: 1em;
  padding-bottom: 1em;
}
a:hover {
  color: black;
  opacity: 0.9;
}

@media (min-width: 768px) {
  #logo {
    width: 315px;
  }
}
</style>
